import React from 'react';
import PropTypes from 'prop-types';
import ClasstivityScheduler from './ClasstivityScheduler/ClasstivityScheduler';
import SchedulesBoard from './SchedulesBoard/SchedulesBoardContainer';

const Schedules = ({ isManualStudio, isMsInventoryVenue, canViewClasstivityScheduler, children }) => {
  if (isMsInventoryVenue && children) {
    return children;
  }

  if (!isMsInventoryVenue && (isManualStudio || canViewClasstivityScheduler)) {
    return <ClasstivityScheduler />;
  }

  return <SchedulesBoard />;
};

Schedules.propTypes = {
  isManualStudio: PropTypes.bool,
  isMsInventoryVenue: PropTypes.bool,
  canViewClasstivityScheduler: PropTypes.bool,
  children: PropTypes.node,
};

export default Schedules;
